import React from "react";
import { Mail } from "@/lib/icons";

export const EMAIL_DELIVERY_NOTE = "If it doesn't appear shortly, please check your Spam or Promotions folder.";
export const withEmailDeliveryNote = (message) => `${message} ${EMAIL_DELIVERY_NOTE}`;

export default function EmailDeliveryNotice({ className = "" }) {
  return (
    <div className={`flex items-start gap-2.5 rounded-xl border border-violet-400/20 bg-violet-500/[0.06] px-3.5 py-3 text-xs leading-5 text-white/60 ${className}`} role="note">
      <Mail size={14} className="mt-0.5 shrink-0 text-violet-300" />
      <span>{EMAIL_DELIVERY_NOTE}</span>
    </div>
  );
}
